import { useState } from "react";
import axios from "axios";
import { message } from "antd";
import Helper from "@/helper";

const useServiceSubmit = ({ form, url, method, t, onSuccessRedirect }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const csrfToken = Helper.getCSRFToken();

  const submitService = async (values) => {
    setIsSubmitting(true);
    form.setFields([]);

    const data = Helper.normalizeFloats(values, ["price_min", "price_max"]);

    try {
      const response = await axios({
        method,
        url,
        data: { chategy_customer_service: data },
        headers: {
          "X-CSRF-Token": csrfToken,
          "Content-Type": "application/json",
        },
      });

      message.success(t("success_message"));

      if (onSuccessRedirect) {
        window.location.href = onSuccessRedirect(response.data);
      }
    } catch (error) {
      console.error(error);
      message.error(t("error_message"));

      const errors = error.response.data.meta.errors;

      if (errors) {
        form.setFields(
          Object.entries(errors).map(([field, messages]) => ({
            name: field,
            errors: messages,
          })),
        );
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return {
    isSubmitting,
    submitService,
  };
};

export default useServiceSubmit;
